module.exports = {
    BREAKPOINTS: {
        medium: 768,
        large: 992,
    }
};